import { SxProps } from '@mui/material';

export const style: SxProps = {
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  justifyContent: 'left',
};
